import { M3UbiAdicionales } from "./M3UbiAdicionales.type";
import { M3Hubs } from "./m3-hubs.type";

export class M3Ubicacion{
    public IDUbicacion:string;
    public Nombre:string;
    public TipoUbicacion:string;
    public TDocAdmin:string;
    public NDocAdmin:string;
    public JConfiguracion:string;
    public Serie:string;
    public Estado:number;
    public DocumentoID:string;
    public M3UbiAdicionales:Array<M3UbiAdicionales>;
    public M3HUBS = new Array<M3Hubs>();
    public FechaTrabajo:Date;
    public APLUbicExternas:Boolean;
    
}